import * as types from 'actions/actionTypes'

import initialState from './initialState'

export const timeZone = (state = initialState.timeZones, action) => {
  switch (action.type) {
    case types.FETCH_TIMEZONES_SUCCESS:
      return { ...state, timeZones: action.payload }
    case types.FETCH_WORK_TIMES_SUCCESS:
      return { ...state, workTimes: action.payload }

    default:
      return state
  }
}
